import { hotWords, indexRank } from "@/mocks/portal";

const TOP_WORDS = hotWords.slice(0, 5);

export default function HotIndex() {
  return (
    <section id="hot" className="scroll-mt-24 bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
              <i className="ri-flashlight-line text-sm"></i>索引 / 合集
            </div>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              检索热榜 · 实时热词
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              站在检索热度的一线，用关键词快速找到大家都在找的专题与内容。
            </p>
          </div>
          <div className="hidden items-center gap-1 rounded-md bg-background-50 px-2 py-1.5 md:flex">
            <i className="ri-pulse-line text-base text-primary-500"></i>
            <span className="text-xs text-foreground-500 whitespace-nowrap">热度每 30 分钟刷新</span>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-5">
          {/* 检索热榜 */}
          <div className="rounded-xl border border-background-200/80 bg-background-50 p-5 md:p-6 lg:col-span-3">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-number-1 text-sm"></i>
                </span>
                内容检索热榜
              </h3>
              <span className="text-xs text-foreground-400 whitespace-nowrap">按检索量排序</span>
            </div>
            <ul className="mt-4 divide-y divide-background-100">
              {indexRank.map((item, i) => (
                <li key={item.text}>
                  <a href="#topics" className="group flex items-center gap-3 px-1 py-3">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                        i < 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-100 text-foreground-500"
                      }`}
                    >
                      {i + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
                        {item.text}
                      </p>
                      <div className="mt-1.5 h-1 w-full max-w-xs overflow-hidden rounded-full bg-background-100">
                        <div
                          className="h-1 rounded-full bg-accent-400"
                          style={{ width: `${Math.round((item.heat / 972) * 100)}%` }}
                        />
                      </div>
                    </div>
                    <span className="hidden rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900 sm:inline whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="w-14 text-right text-xs tabular-nums text-foreground-500">
                      {item.heat.toLocaleString()}
                    </span>
                    <i className="ri-arrow-right-line text-sm text-foreground-300 transition-all group-hover:translate-x-0.5 group-hover:text-primary-600"></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 实时热词云 */}
          <div className="flex flex-col rounded-xl border border-background-200/80 bg-background-50 p-5 md:p-6 lg:col-span-2">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className="ri-chat-voice-line text-sm"></i>
                </span>
                实时检索热词
              </h3>
              <a href="#query" className="text-xs font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap">
                查询更多 <i className="ri-arrow-right-up-line align-middle"></i>
              </a>
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotWords.map((w, i) => (
                <a
                  key={w.text}
                  href="#topics"
                  style={{ fontSize: `${Math.max(13, 24 - i)}px` }}
                  className={`rounded-lg px-3 py-1.5 font-semibold transition-colors whitespace-nowrap ${
                    i % 4 === 0
                      ? "bg-primary-50 text-primary-700 hover:bg-primary-100"
                      : i % 4 === 1
                      ? "bg-accent-50 text-accent-800 hover:bg-accent-100"
                      : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
                  }`}
                >
                  {w.text}
                  <span className="ml-1 align-middle text-[10px] font-normal opacity-60">{w.heat}</span>
                </a>
              ))}
            </div>
            <div className="mt-auto hidden items-center gap-2 rounded-lg bg-background-100/70 px-3 py-2.5 md:flex">
              <i className="ri-search-eye-line text-sm text-primary-500"></i>
              <span className="text-xs text-foreground-500">
                想查的词不在上面？直接到搜索框输入，会自动归入「检索热词」。
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}